import { SubMenuIcon } from '@model-framework/menu';
import { SubMenuBox } from '@model-framework/menu/MenuBox';
import { faAlignLeft, faAlignCenter, faAlignRight } from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { TextAlign } from './TextAlign';

type Props = {
  textAlign: TextAlign;
  menuSize: number;
  isSelected: boolean;
  onClick(): void;
};

const textAlignToIcon: { [key in TextAlign]: IconDefinition } = {
  [TextAlign.Left]: faAlignLeft,
  [TextAlign.Center]: faAlignCenter,
  [TextAlign.Right]: faAlignRight,
};

export const TextAlignSubMenu: React.FC<Props> = ({ textAlign, menuSize, isSelected, onClick }: Props) => {
  return (
    <>
      <SubMenuBox menuSize={menuSize} isSelected={isSelected} onClick={onClick} />
      <SubMenuIcon icon={textAlignToIcon[textAlign]} menuSize={menuSize} isSelected={isSelected} />
    </>
  );
};
